/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { AirportSvg, Alert, Card, EscalatorSvg, FeederSvg, List, PaidPorter, ParkingSvg, RightArr, RouteSvg, Station, StationService, TableSearch, WheelChairSvg } from "../../common/svg/AllSvg";
import { url } from "../../../shared/utils/url";
import useAxios from "../../../shared/hooks/use-axios";
import NoSearch from "../../common/form/NoSearch";
import EmptyList from "../../common/form/EmptyList";
import Error from "../../common/form/Error";
import { useDeviceType } from "../../../shared/utils/useDeviceType";

const Details = ({ view, setView, setSearch, search, sts, tab, setTab, line, loading, isError }: any) => {
  const lang: string = useSelector((state: any) => state.ui.lang);
  const [hover, setHover] = useState<any>(null)
  const { t } = useTranslation('common');
  const params = useParams();
  const navigate = useNavigate();
  const [lineUpdates, setLineUpdates] = useState<any[]>([]);
  const [lineLoading, setLineLoading] = useState<boolean>(true);
  const [lineError, setLineError] = useState<boolean>(false);
  const loaderData: any[] = [1, 2, 3, 4, 5]
  const [stUpdates, setStUpdates] = useState<any[]>([]);
  const [searchFocus, setSearchFocus] = useState<boolean>(false)
  const [tabFocus, setTabFocus] = useState<any>(null)
  const isMobile = useDeviceType();
  const tabs: any[] = [{ name: t("passenger.line.tabs.tab1"), key: "metro_st" }, { name: t("passenger.line.tabs.tab2"), key: "ln_upd" }, { name: t("passenger.line.tabs.tab3"), key: "st_upd" }]

  const getFacilities = (item: any) => {
    let arr: any[] = []
    for (let i = 0; i < item?.facility?.length; i++) {
      const el = item?.facility?.[i];
      arr.push(
        <span key={i} title={el?.name} aria-label={el?.name}>
          {el?.class_name === "divyang-friendly" ?
            <WheelChairSvg className="min-w-[21px] w-[21px] h-[21px]" /> :
            el?.class_name === "lift" ?
              <EscalatorSvg className="min-w-[21px] w-[21px] h-[21px]" /> :
              el?.class_name === "parking" ?
                <ParkingSvg className="min-w-[21px] w-[21px] h-[21px]" /> :
                el?.class_name === "interchange" ?
                  <RouteSvg className="min-w-[19px] w-[19px] h-[19px]" /> :
                  el?.class_name === "feeder-bus" ?
                    <FeederSvg className="min-w-[23px] w-[23px] h-[23px]" /> :
                    el?.class_name === "airport" ?
                      <AirportSvg className="min-w-[20px] w-[20px] h-[20px]" /> :
                      el?.class_name === "paid-porter" ?
                        <PaidPorter className="min-w-[23px] w-[23px] h-[23px]" /> : ""
          }
        </span>
      )
    }
    return arr;
  }

  const getUpdates = async () => {
    try {
      setLineLoading(true)
      setLineError(false)
      const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.updates + line?.line_code}/`);

      if (res && res?.status === 200) {
        setLineUpdates(!!res?.data?.[1]?.line_updates[0] ? res?.data?.[1]?.line_updates[0] : [])
        setStUpdates(!!res?.data?.[1]?.stations_updates ? res?.data?.[1]?.stations_updates : [])
        setLineLoading(false)
      }
    } catch (error) {
      setLineLoading(false)
      setLineError(true)
      console.error("error while feching lines data", error);
    }
  }

  useEffect(() => {
    (!!lang && !!line?.line_code) && getUpdates();
  }, [lang, line])

  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full bg-[#0A2540] h-[42px]">
        <div className="flex w-full h-full overflow-x-auto container gap-[10px]">
          {Array.isArray(tabs) && tabs?.map((item: any, index: number) => (
            <button className={`h-full flex items-center gap-[10px] px-[12px] ${tab === index ? "border-b-2 border-white rounded-t-full" : "border-b-2 border-[#0A2540] rounded-t-full"} whitespace-nowrap group`} key={index} onClick={() => setTab(index)} onFocus={() => setTabFocus(index)} onBlur={() => setTabFocus(null)}>
              <h5 className={`${tab === index ? "text-white" : `${index === tabFocus ? "text-white" : "text-white text-opacity-[0.7]"} group-hover:text-white`} font-medium whitespace-nowrap capitalize`}>{item?.name}</h5>
              <div className={`${tab === index ? "bg-white text-white" : `${index === tabFocus ? "text-white" : "bg-primary text-[#B5B5B5]"} group-hover:text-white`} rounded-[10px] bg-opacity-[0.1] text-base font-bold h-[25px] flex items-center justify-center px-[12px] !leading-tight`}>
                {index === 0 ? sts?.length : index === 1 ? lineUpdates?.length : stUpdates?.length}
              </div>
            </button>
          ))}
        </div>
      </div>

      <div className="w-full h-full container pt-[30px] pb-[60px] xlx:pt-[40px] xlx:pb-[95px] flex items-center justify-center">
        {tab === 0 ? <>
          <div className="w-full flex flex-col gap-[20px] xlx:gap-[25px]">
            <div className="flex md:items-center justify-between w-full md:flex-row flex-col gap-[13px]">
              <div className="flex items-center justify-between w-full">
                <h3 className="text-primary font-bold text-[1.8rem]">{(sts?.length > 0 && !!search) ? `${lang === "en" ? `Showing Result for ${sts?.length} Filter` : lang === "hi" ? `${sts?.length} फ़िल्टर के लिए परिणाम दिखाया जा रहा है` : `${sts?.length} फिल्टरसाठी परिणाम दर्शवित आहे`}` : `${t("passenger.line.metro_st")}`}</h3>
                <div className="flex items-center gap-[8px]">
                  <div className="h-[40px] xlx:h-[45px] rounded-[12px] bg-[#D9D9D9] bg-opacity-[0.3] px-[5px] flex items-center md:hidden gap-[4px]">
                    <button aria-label={t("aria_label.card")} title={t("aria_label.card")} className={`min-w-[35px] xlx:min-w-[40px] h-[30px] xlx:h-[35px] flex items-center justify-center rounded-[8px] ${view === "card" ? "bg-white shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "focus:shadow-[0_0_0_2px_#4E566D5e] hover:shadow-[0_0_0_2px_#4E566D5e]"}`} onClick={() => setView("card")}><Card className={`${view === "card" ? "fill-primary" : "fill-blackDull opacity-[0.5]"}`} /></button>
                    <button aria-label={t("aria_label.list")} title={t("aria_label.list")} className={`min-w-[35px] xlx:min-w-[40px] h-[30px] xlx:h-[35px] flex items-center justify-center rounded-[8px] ${view === "list" ? "bg-white shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "focus:shadow-[0_0_0_2px_#4E566D5e] hover:shadow-[0_0_0_2px_#4E566D5e]"}`} onClick={() => setView("list")}><List className={`${view === "list" ? "fill-primary" : "fill-blackDull opacity-[0.5]"}`} /></button>
                  </div>
                </div>
              </div>

              {(!!search || sts?.length > 0) && <div className="flex items-center gap-[10px] md:w-auto w-full justify-end">
                <div className={`border border-[rgba(134,134,134,0.15)] h-[40px] xlx:h-[45px] px-[12px] xlx:px-[15px] flex items-center gap-[8px] xlx:gap-[12px] rounded-[12px] w-[315px] ${searchFocus && "shadow-lg dark:border-[#ffffff5e]"} hover:shadow-lg dark:hover:border-[#ffffff5e]`}>
                  <TableSearch className="xlx:w-[18px] xlx:min-w-[18px] xlx:h-[18px] min-w-[15px] w-[15px] h-[15px] fill-blackDull dark:fill-white opacity-[0.7]" />

                  <input type="text" className="text-opacity-[0.7] text-blackDull font-medium placeholder:text-blackDull placeholder:text-opacity-[0.7] text-sm leading-snug w-full dark:text-textBlackDull placeholder:dark:text-textBlackDull bg-transparent" placeholder={t("passenger.home.know_st.st.search")} autoComplete="off" value={search} onChange={(e: any) => setSearch(e.target.value)} onFocus={() => setSearchFocus(true)} onBlur={() => setSearchFocus(false)} />
                </div>

                <div className="h-[40px] xlx:h-[45px] rounded-[12px] bg-[#D9D9D9] bg-opacity-[0.3] px-[5px] hidden items-center md:flex gap-[4px]">
                  <button aria-label={t("aria_label.card")} title={t("aria_label.card")} className={`min-w-[35px] xlx:min-w-[40px] h-[30px] xlx:h-[35px] flex items-center justify-center rounded-[8px] ${view === "card" ? "bg-white dark:bg-bgDarkDull shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "focus:shadow-[0_0_0_2px_#4E566D5e] hover:shadow-[0_0_0_2px_#4E566D5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"}`} onClick={() => setView("card")}><Card className={`${view === "card" ? "fill-primary" : "fill-blackDull dark:fill-white opacity-[0.5]"}`} /></button>
                  <button aria-label={t("aria_label.list")} title={t("aria_label.list")} className={`min-w-[35px] xlx:min-w-[40px] h-[30px] xlx:h-[35px] flex items-center justify-center rounded-[8px] ${view === "list" ? "bg-white dark:bg-bgDarkDull shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "focus:shadow-[0_0_0_2px_#4E566D5e] hover:shadow-[0_0_0_2px_#4E566D5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"}`} onClick={() => setView("list")}><List className={`${view === "list" ? "fill-primary" : "fill-blackDull dark:fill-white opacity-[0.5]"}`} /></button>
                </div>
              </div>}
            </div>

            {loading ?
              <>
                {view === "card" ?
                  <div className="grid grid-cols-1 md:grid-cols-2 msm:grid-cols-3 xlx:grid-cols-4 gap-[15px]">
                    {Array.isArray(loaderData) && loaderData?.map((item: any, index: number) => (
                      <div key={index} className="border border-gray-200 dark:border-gray-700 shadow rounded-[20px] w-full h-[230px] md:h-[250px] animate-pulse">
                        <div className="flex items-center justify-center rounded-t-[20px] h-[calc(100%-50px)] xl:h-[calc(100%-60px)] w-full bg-gray-300 dark:bg-gray-700">
                          <svg className="w-[40px] h-[40px] text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                            <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                          </svg>
                        </div>

                        <div className="h-[50px] xl:h-[60px] flex items-center px-[19px] py-[15px] xl:py-[18px]">
                          <div className="w-[150px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                  :
                  <div className="overflow-x-auto h-full w-full">
                    <div className="inline-block min-w-full">
                      <div className="overflow-hidden">
                        <table className="table-auto w-full">
                          <tbody>
                            {Array.isArray(loaderData) && loaderData?.map((item: any, index: number) => (
                              <tr key={index} className="border border-gray-200 dark:border-gray-700 animate-pulse">
                                <td className="pl-[20px] xlx:pl-[30px] pr-[16px] py-[15px] xlx:py-[20px]">
                                  <div className="w-[97px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                </td>
                                <td className="px-[16px] py-[15px] xlx:py-[20px]">
                                  <div className="flex flex-col gap-[4px]">
                                    <div className="w-[76px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                    <div className="h-[25px] flex items-center justify-center rounded-[50px] bg-gray-200 dark:bg-gray-700 w-[52px]">
                                    </div>
                                  </div>
                                </td>
                                <td className="px-[16px] py-[15px] xlx:py-[20px]">
                                  <div className="flex flex-col gap-[4px]">
                                    <div className="w-[45px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>

                                    <div className="flex items-center gap-[4px]">
                                      {Array.isArray(loaderData) && loaderData?.map((i: any, idx: number) => (
                                        <div key={idx} className="h-[20px] bg-gray-200 dark:bg-gray-700 w-[20px] rounded-sm">
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </td>

                                <td className="pl-[16px] pr-[20px] xlx:pr-[30px] py-[15px] xlx:py-[20px]">
                                  <div className="w-full flex items-center justify-end">
                                    <div className="w-[160px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                }
              </>
              :
              <>
                {isError ? <Error /> : <>
                  {sts?.length > 0 && <>
                    {view === "card" ? <div className="grid grid-cols-1 md:grid-cols-2 msm:grid-cols-3 xlx:grid-cols-4 gap-[15px]">
                      {Array.isArray(sts) && sts?.map((item: any, index: number) => (
                        <button key={index} className={`border border-[#F1F1F1] bg-white ${hover === index ? "shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)]" : ""} w-full h-[230px] md:h-[250px] rounded-[20px] relative`} onMouseEnter={() => setHover(index)} onMouseLeave={() => setHover(null)} onClick={() => { setHover(index); !!params?.lang ? navigate(`/${params?.lang}/station/${item?.code}`) : navigate(`/station/${item?.code}`); }} onFocus={() => !isMobile && setHover(index)} onBlur={() => setHover(null)}>
                          <div className="flex items-start justify-start h-full relative">
                            <img src={item?.image?.file} alt={item?.name} className="rounded-t-[20px] h-[calc(100%-50px)] xl:h-[calc(100%-60px)] w-full" />

                            {hover !== index && <div className="absolute top-0 left-0 right-0 bottom-0 p-[15px]">
                              <div className={`h-[25px] flex items-center justify-center px-[11px] ${item?.station_status?.length > 0 ? "bg-secDarkRed" : "bg-success"} text-white font-bold uppercase rounded-[50px] text-xs w-fit !leading-[18px]`}>
                                {item?.station_status?.length > 0 ? `${lang === "en" ? "Closed" : lang === "hi" ? "बंद" : "बंद"}` : `${lang === "en" ? "Open" : lang === "hi" ? "खुला" : "उघडा"}`}
                              </div>
                            </div>}
                          </div>
                          <div className={`rounded-b-[20px] transition-all duration-100 px-[19px] py-[15px] xl:py-[18px] absolute left-0 right-0 bottom-0 ${hover === index ? "h-[130px] xlx:h-[148px]" : "h-[50px] xl:h-[60px] flex items-center flex-col"} bg-white`}>
                            <div className="flex items-center gap-[8px] xlx:gap-[10px] w-full justify-start">
                              <Station className="fill-primaryText xlx:w-auto xlx:h-auto w-[16px] h-[20px]" />
                              <h4 className="text-primaryText font-bold line-clamp-1">{item?.name}</h4>
                            </div>

                            <div className={`gap-[10px] xlx:gap-[15px] pt-[30px] xlx:pt-[40px] ${hover === index ? "flex" : "hidden"}`}>
                              <div className="flex flex-col gap-[6px] xlx:gap-[9px] whitespace-nowrap">
                                <p className="text-xs font-bold text-blackDull text-left">{t("passenger.home.know_st.st.st_status")}</p>

                                <div className={`h-[25px] flex items-center justify-center px-[11px] ${item?.station_status?.length > 0 ? "bg-secDarkRed" : "bg-success"} text-white font-bold uppercase rounded-[50px] text-xs w-fit !leading-tight`}>
                                  {item?.station_status?.length > 0 ? `${lang === "en" ? "Closed" : lang === "hi" ? "बंद" : "बंद"}` : `${lang === "en" ? "Open" : lang === "hi" ? "खुला" : "उघडा"}`}
                                </div>
                              </div>

                              <div className="flex flex-col gap-[6px] xlx:gap-[9px] whitespace-nowrap">
                                <p className="text-xs font-bold text-blackDull text-left !leading-tight">{t("passenger.home.know_st.st.line_status")}</p>
                                <div className="h-[25px] flex items-center justify-center px-[11px] bg-primary text-white font-bold uppercase rounded-[50px] text-xs w-fit gap-[4px] !leading-tight">
                                  {item?.metro_lines?.[0]?.name} <StationService className={`${(item?.metro_lines?.[0]?.status === "Normal Service" || item?.metro_lines?.[0]?.status === "सामान्य सेवाएँ" || item?.metro_lines?.[0]?.status === "सामान्य सेवा") ? "fill-success" : (item?.metro_lines?.[0]?.status === "Delay in Service" || item?.metro_lines?.[0]?.status === "सेवा में देरी" || item?.metro_lines?.[0]?.status === "सेवेत विलंब") ? "fill-[#D4741B]" : (item?.metro_lines?.[0]?.status === "No Service" || item?.service_status === "सेवा निषेद" || item?.metro_lines?.[0]?.status === "सेवा नाही") ? "fill-secDarkRed" : "fill-[#B2AE45]"}`} />
                                  {item?.metro_lines?.[0]?.status}
                                </div>
                              </div>
                            </div>
                          </div>

                        </button>
                      ))}
                    </div> :
                      <div className="overflow-x-auto h-full w-full">
                        <div className="inline-block min-w-full">
                          <div className="overflow-hidden">
                            <table className="table-auto w-full">
                              <tbody>
                                {Array.isArray(sts) && sts.map((item: any, index: number) => (
                                  <tr key={index} className="border border-[#E7E8EC]">
                                    <td className="pl-[20px] xlx:pl-[30px] pr-[16px] py-[15px] xlx:py-[20px]">
                                      <div className="flex items-center gap-[8px] xlx:gap-[10px] w-full justify-start whitespace-nowrap">
                                        <Station className="fill-primaryText dark:fill-white xlx:w-auto xlx:h-auto w-[16px] h-[20px]" />
                                        <h4 className="text-primaryText dark:text-white font-bold">{item?.name}</h4>
                                      </div>
                                    </td>

                                    <td className="px-[16px] py-[15px] xlx:py-[20px]">
                                      <div className="flex flex-col gap-[6px] whitespace-nowrap">
                                        <p className="text-xs font-bold text-blackDull dark:text-textBlackDull text-left">{t("passenger.home.know_st.st.st_status")}</p>

                                        <div className={`h-[25px] flex items-center justify-center px-[11px] ${item?.station_status?.length > 0 ? "bg-secDarkRed" : "bg-success"} text-white font-bold uppercase rounded-[50px] text-xs w-fit !leading-tight`}>
                                          {item?.station_status?.length > 0 ? `${lang === "en" ? "Closed" : lang === "hi" ? "बंद" : "बंद"}` : `${lang === "en" ? "Open" : lang === "hi" ? "खुला" : "उघडा"}`}
                                        </div>
                                      </div>
                                    </td>

                                    <td className="px-[16px] py-[15px] xlx:py-[20px]">
                                      <div className="flex flex-col gap-[6px] whitespace-nowrap">
                                        <p className="text-xs font-bold text-blackDull dark:text-textBlackDull text-left">{t("passenger.home.service.facilities")}</p>

                                        <div className="flex items-center gap-[6px] xlx:gap-[8px]">
                                          {getFacilities(item)}
                                        </div>
                                      </div>
                                    </td>

                                    <td className="pl-[16px] pr-[20px] xlx:pr-[30px] py-[15px] xlx:py-[20px]">
                                      <div className="w-full flex items-center justify-end">
                                        <button className="flex items-center justify-center gap-[6px] xlx:gap-[9px] whitespace-nowrap hover:underline focus:underline text-blackDull dark:text-textBlackDull text-opacity-[0.7]" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/station/${item?.code}`) : navigate(`/station/${item?.code}`)}>
                                          <h5 className="text-blackDull dark:text-textBlackDull text-opacity-[0.7] font-medium">{t("passenger.station_detail.view_st")}</h5>
                                          <RightArr className="opacity-[0.7] min-w-[9px] xlx:min-w-[10px] xlx:w-auto xlx:h-auto w-[9px] h-[15px] fill-blackDull dark:fill-textBlackDull" />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    }
                  </>}

                  {((!!!search) && sts?.length === 0) &&
                    <EmptyList />
                  }

                  {(!!search && sts?.length === 0) &&
                    <NoSearch onClick={() => { setSearch("") }} />
                  }
                </>}
              </>}
          </div>
        </> :
          tab === 1 ? <>
            {lineLoading ?
              <div className="w-full border border-gray-200 dark:border-gray-700 animate-pulse">
                {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                  <div className={`${(index + 1 === loaderData?.length) ? "" : "border-b dark:border-[#454545] border-[#E7E8EC]"} w-full p-[15px] sm:px-[30px] xlx:px-[38px] sm:py-[20px] xlx:py-[24px] gap-[20px] xlx:gap-[30px] flex items-center`} key={index}>
                    <div className="min-w-[40px] xlx:min-w-[50px] h-[40px] xlx:h-[50px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                    <div className="flex flex-col gap-[5px] w-full">
                      <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                      <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                    </div>
                  </div>
                ))}
              </div>
              :
              <>
                {lineError ? <Error /> : <>
                  {lineUpdates?.length > 0 && <div className="w-[1085px] border dark:border-[#454545] border-[#E7E8EC]">
                    {Array.isArray(lineUpdates) && lineUpdates.map((item: any, index: number) => (
                      <div className={`${(index + 1 === lineUpdates?.length) ? "" : "border-b dark:border-[#454545] border-[#E7E8EC]"} w-full p-[15px] sm:px-[30px] xlx:px-[38px] sm:py-[20px] xlx:py-[24px] gap-[20px] xlx:gap-[30px] flex items-center`}>
                        <div className="min-w-[40px] xlx:min-w-[50px] h-[40px] xlx:h-[50px] flex items-center justify-center rounded-full bg-[#F4B6B7] dark:bg-opacity-[0.9] bg-opacity-[0.5]">
                          <Alert />
                        </div>

                        <div className="flex flex-col gap-[4px]">
                          <h5 className="text-primary font-bold uppercase">{item?.title}</h5>
                          {!!item?.note && <h5 className="text-blackDull dark:text-textBlackDull font-medium">{item?.note}</h5>}
                        </div>
                      </div>
                    ))}
                  </div>}

                  {lineUpdates?.length === 0 && <EmptyList />}
                </>}
              </>}
          </> :
            <>
              {lineLoading ?
                <div className="w-full border border-gray-200 dark:border-gray-700 animate-pulse">
                  {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                    <div className={`${(index + 1 === loaderData?.length) ? "" : "border-b dark:border-[#454545] border-[#E7E8EC]"} w-full p-[15px] sm:px-[30px] xlx:px-[38px] sm:py-[20px] xlx:py-[24px] gap-[20px] xlx:gap-[30px] flex items-center`} key={index}>
                      <div className="min-w-[40px] xlx:min-w-[50px] h-[40px] xlx:h-[50px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                      <div className="flex flex-col gap-[5px] w-full">
                        <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                        <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                      </div>
                    </div>
                  ))}
                </div>
                :
                <>
                  {lineError ? <Error /> : <>
                    {stUpdates?.length > 0 && <div className="w-[1085px] border dark:border-[#454545] border-[#E7E8EC]">
                      {Array.isArray(stUpdates) && stUpdates.map((item: any, index: number) => (
                        <div className={`${(index + 1 === stUpdates?.length) ? "" : "border-b dark:border-[#454545] border-[#E7E8EC]"} w-full p-[15px] sm:px-[30px] xlx:px-[38px] sm:py-[20px] xlx:py-[24px] gap-[20px] xlx:gap-[30px] flex items-center`}>
                          <div className="min-w-[40px] xlx:min-w-[50px] h-[40px] xlx:h-[50px] flex items-center justify-center rounded-full bg-[#F4B6B7] dark:bg-opacity-[0.9] bg-opacity-[0.5]">
                            <Alert />
                          </div>

                          <div className="flex flex-col gap-[4px]">
                            <h5 className="text-primary font-bold uppercase">{item?.station?.name}</h5>
                            <div className="flex flex-col">
                              {!!item?.title && <h5 className="text-blackDark dark:text-textBlackDark font-semibold">{item?.title}</h5>}
                              {!!item?.note && <h6 className="text-blackDull dark:text-textBlackDull font-medium">{item?.note}</h6>}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>}

                    {stUpdates?.length === 0 && <EmptyList />}
                  </>}
                </>}
            </>
        }

      </div>
    </div>
  );
};

export default Details;